export default __webpack_public_path__ + "static/media/aalduz.570e64dc.jpg";